module.exports = __webpack_public_path__ + "img/icon-xinyan.7c4d231d.webp";